import { Injectable } from "@angular/core";
import { DataAccessService } from "@pmis3/data-access";
import { Observable, tap, map } from "rxjs";
import { IVesselVisit } from "./model";
import { IQueryResult } from "@pmis3/data-access";
import { LoadVesselVisits } from "./actions/vesselVisit.action";
import { Store } from "@ngrx/store";
import { AppState } from "@pmis3/data-access";
import { IDateTimeRange } from "@pmis3/utils";
import { ICommonDataAttribute } from "@pmis3/data-access";

@Injectable()
export class VesselVisitService {
    readonly endpoint = "vv";
    nextVoyageNumber = 0;

    constructor(private _api: DataAccessService, private store: Store<AppState>) {
        this.store.dispatch(LoadVesselVisits());
    }

    private _parseItems(r: IQueryResult<IVesselVisit>): IQueryResult<IVesselVisit> {
        r.items = r.items?.map(item => this._mapToIVessel(item));
        return r;
    }

    private _mapToIVessel(data: any) {
        const attributes = data.attributes as ICommonDataAttribute[];
        
        const voyageNumber = attributes?.find(attr => attr.attributeName === VesselVisitAttributes.VoyageNumber)?.jsonValue;
        const nextPortOfCallId = attributes?.find(attr => attr.attributeName === VesselVisitAttributes.NextPortOfCall)?.jsonValue;
        
        return {
            id: data.id,
            vesselId: data.vesselId,
            vessel: data.vessel,
            agencyId: data.agencyId,
            vesselActivities: [],
            dateTimeFrom: data.dateTimeFrom,
            dateTimeTo: data.dateTimeTo,
            voyageNumber: voyageNumber?.toString() ?? this._getVoyageNumberForTest(),
            nextPortOfCallId: nextPortOfCallId ?? this._getNextPortOfCallIdForTest(),
            lastPortOfCallId: this._getLastPortOfCallIdForTest(),
            status: data.visitStatus
        };
    }

    private _getNextPortOfCallIdForTest() {
        return 345
    }

    private _getLastPortOfCallIdForTest() {
        return 123
    }

    private _getVoyageNumberForTest() {
        return '1234'
    }

    getNextVoyageNumber() {
        return this.nextVoyageNumber++;
    }

    getAllVesselVisits(): Observable<IQueryResult<IVesselVisit>> {
        return this._api.queryEntity<IVesselVisit>(this.endpoint, "", { pageSize: 1000}).pipe(tap(r => this._parseItems(r)));
    }

    getVesselVisitsByDateRange(dateRange: IDateTimeRange): Observable<IQueryResult<IVesselVisit>> {
        const params = new Map<string, string>();
        params.set("datetimefrom", dateRange.dateTimeFrom.toISOString());
        params.set("datetimeto", dateRange.dateTimeTo.toISOString());
        return this._api.queryEntity<IVesselVisit>(this.endpoint, "bydaterange", { pageSize: 10000, params })
                .pipe(tap(r => this._parseItems(r)));
    }
}

enum VesselVisitAttributes {
    VoyageNumber = "voyageNumber",
    NextPortOfCall = "JsonData.nextPortOfCallId",
}
